import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { CurrencyPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Signal,
  computed,
  input,
  output,
} from '@angular/core';
import { ServiceProviderHandler } from '@principle-theorem/principle-core';
import {
  IMohClaimableItem,
  IPricedServiceCodeEntry,
  isPricedServiceCodeEntry,
} from '@principle-theorem/principle-core/interfaces';
import { TypeGuard } from '@principle-theorem/shared';

interface ITreatmentRow {
  description: string;
  quantity: number;
  price: number;
  uid?: string;
}

interface ITreatmentCommentChange {
  comment: string;
  uid?: string;
}

@Component({
  selector: 'pr-moh-treatment-list-card',
  imports: [CurrencyPipe, CdkTextareaAutosize],
  templateUrl: './moh-treatment-list-card.component.html',
  styleUrl: './moh-treatment-list-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MohTreatmentListCardComponent {
  title = input.required<string>();
  codes = input.required<IMohClaimableItem[] | IPricedServiceCodeEntry[]>();
  enableComments = input(false);
  commentChange = output<ITreatmentCommentChange>();

  treatmentItems: Signal<ITreatmentRow[]> = computed(() => {
    const codeItems = this.codes();

    if (TypeGuard.arrayOf(isPricedServiceCodeEntry)(codeItems)) {
      return codeItems.map((item) => ({
        description: this._getCodeDescription(item),
        quantity: item.quantity,
        price: item.price,
      }));
    }

    return codeItems.map((item) => ({
      description: item.serviceCode.description,
      quantity: item.quantity,
      price: item.serviceCode.amount,
      uid: item.serviceCode.uid,
    }));
  });

  private _getCodeDescription(code: IPricedServiceCodeEntry): string {
    const resolvedCode = ServiceProviderHandler.resolveServiceCode(
      code.type,
      code.code
    );
    if (!resolvedCode) {
      return '';
    }
    return `${resolvedCode.code} - ${resolvedCode.title}`;
  }
}
